import React, { useContext, useEffect, useState } from 'react'
import { Container, ContainerOutlet, ContentWrapper } from './style'
import UserContext from '../../contexts/UserContext'
import jwtDecode, { JwtPayload } from 'jwt-decode'
import ModalContext from '../../contexts/ModalContext'
import BaseModal from '../../components/Modal'
import FeedbackComponent from '../../components/FeedbackComponent'
import { FeedbackContext } from '../../contexts/FeedbackContext'
import { Outlet, useLocation } from 'react-router-dom'
import HeaderComponent from '../../components/Header'
import ChatSidebar from '../../components/ChatSidebar'
import { NotificationProvider } from '../../contexts/NotificationContext'

interface DecodedUser extends JwtPayload {
  email: string
  name: string
}

export interface TypeMainOutlet {
  search: string
  setSearch: React.Dispatch<React.SetStateAction<string>>
}

const ClientPanel = () => {
  const { user } = useContext(UserContext)
  const { modalActive } = useContext(ModalContext)
  const { feedback } = useContext(FeedbackContext)
  const [search, setSearch] = useState<string>('')
  const [isValidating, setIsValidating] = useState(true)
  const [isChatOpen, setIsChatOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if ((location.state as any)?.returnSearch !== undefined) {
      setSearch((location.state as any).returnSearch)
    } else {
      setSearch('');
    }
  }, [location.pathname]);
  

  useEffect(() => {
    console.log('🔍 [CLIENT-PANEL] Pesquisa Global atualizada:', {
      termo: search,
      caracteres: search.length,
      timestamp: new Date().toLocaleTimeString()
    });
  }, [search]);

  useEffect(() => {
    console.log('🔑 [CLIENT-PANEL] Montando componente, iniciando validação:', {
      hasUser: !!user,
      userId: user?.id || user?.sub,
      userEmail: user?.email,
      userApproved: user?.approved,
      userTenantId: user?.tenantId
    })
    
    const timer = setTimeout(() => {
      console.log('🔑 [CLIENT-PANEL] Timer de validação expirado, setando isValidating = false')
      setIsValidating(false)
    }, 200)
    
    return () => clearTimeout(timer)
  }, [])

  console.log('🔑 [CLIENT-PANEL] Render - Estado atual:', {
    isValidating,
    hasUser: !!user,
    userId: user?.id || user?.sub,
    userApproved: user?.approved,
    timestamp: new Date().toISOString()
  })

  if (isValidating) {
    console.log('🔑 [CLIENT-PANEL] Ainda validando, retornando null')
    return null
  }

  if (!user || (!user.id && !user.sub)) {
    console.log('🔑 [CLIENT-PANEL] Usuário não encontrado, retornando null')
    return null
  }

  if (user.approved && user.approved !== 'approved') {
    if (user.approved === 'pending') {
      console.log('⚠️ [CLIENT-PANEL] Usuário pendente, redirecionando para /accessvalidation')
      window.location.href = '/accessvalidation'
      return null
    } else if (user.approved === 'denied') {
      console.log('⚠️ [CLIENT-PANEL] Usuário negado, removendo token e redirecionando para /')
      localStorage.removeItem('token')
      window.location.href = '/'
      return null
    }
  }
  
  console.log('✅ [CLIENT-PANEL] Usuário aprovado, renderizando painel')

  console.log('✅ [CLIENT-PANEL] Renderizando painel com contexto:', { 
    contextSearch: search,
    outletActive: true 
  });
  
  return (
    <NotificationProvider>
      <Container>
        <HeaderComponent
          search={search}
          setSearch={setSearch}
          isChatOpen={isChatOpen}
          onToggleChat={() => setIsChatOpen((v) => !v)}
        />
        {modalActive && <BaseModal />}
        {feedback.isOpen && <FeedbackComponent />}
        <ContentWrapper>
          <ContainerOutlet>
            <Outlet context={{ search, setSearch }} />
          </ContainerOutlet>
        </ContentWrapper>
        <ChatSidebar
          isOpen={isChatOpen}
          onClose={() => setIsChatOpen(false)}
        />
      </Container>
    </NotificationProvider>
  )
}

export default ClientPanel
